import { render, staticRenderFns } from "./SuspendUser.vue?vue&type=template&id=44cbf0d7&scoped=true&"
import script from "./SuspendUser.vue?vue&type=script&lang=js&"
export * from "./SuspendUser.vue?vue&type=script&lang=js&"
import style0 from "./SuspendUser.vue?vue&type=style&index=0&id=44cbf0d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cbf0d7",
  null
  
)

export default component.exports